// extracted by mini-css-extract-plugin
export default {"form-pages":"styles__form-pages--3Rip5","form-page":"styles__form-page--P3ayN","large":"styles__large--Klck3","hidden":"styles__hidden--zE2iw"};